import PropTypes from 'prop-types';

import { productFromGraphQlProductInterface, propTypeRawShapeToExtend } from './product';

export const accessoryFromGraphQlProductInterface = productFromGraphQlProductInterface;

export const propType = PropTypes.shape(propTypeRawShapeToExtend);
